module.exports = require('imports-loader?Blockly=../shim/blocks_compressed_vertical-blockly_compressed_vertical-messages,goog=../shim/blockly_compressed_vertical.goog!exports-loader?Blockly!../msg/scratch_msgs');



//////////////////
// WEBPACK FOOTER
// ./~/scratch-blocks/shim/vertical.js
// module id = 50
// module chunks = 0